import type {AddComponentTypeOptions} from 'grapesjs';
import {asteriskHtml, createBaseBoxComponent} from '@FormMakerReact/components/create-base-box-component';
import {PHONE_BOX_STYLES} from '@FormMakerReact/components/component-styles';
import {POSTERMYWALL_FORM_SPACER_TYPE} from '@FormMakerReact/components/postermywall-form-spacer/postermywall-form-spacer';
import {POSTERMYWALL_FORM_TEXT_TYPE} from '@FormMakerReact/components/postermywall-form-text/postermywall-form-text';
import {POSTERMYWALL_COUNTRY_CODE_INPUT_TYPE} from '@FormMakerReact/components/postermywall-country-code-input/postermywall-country-code-input';
import {POSTERMYWALL_PHONE_INPUT_TYPE} from '@FormMakerReact/components/postermywall-phone-input/postermywall-phone-input';

export const POSTERMYWALL_PHONE_BOX_TYPE = 'postermywall-phone-box';

export const POSTERMYWALL_PHONE_BOX: AddComponentTypeOptions = createBaseBoxComponent({
  boxType: POSTERMYWALL_PHONE_BOX_TYPE,
  dataMarkerAttribute: 'data-is-pmw-form-phone-box',
  components: [
    {type: POSTERMYWALL_FORM_SPACER_TYPE},
    {type: POSTERMYWALL_FORM_TEXT_TYPE, content: `<strong>Phone number${asteriskHtml()}</strong>`},
    {
      tagName: 'div',
      style: PHONE_BOX_STYLES,
      components: [{type: POSTERMYWALL_COUNTRY_CODE_INPUT_TYPE}, {type: POSTERMYWALL_PHONE_INPUT_TYPE}],
    },
  ],
});
